module.exports = __webpack_public_path__ + "app2.png?26660dbf95e8b1b3dc2dce1bb3b5fcc8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/photoplio/app2.png
// module id = 74
// module chunks = 0